'use strict';

var Utils = require('../utils/utils');

// Constructor
var Collapse = function() {

  var self = this;

  self.config = {
    'button'       :  $('[data-collapse]'),
    'containerEl'  :  $('.collapse')
  }

  self.clickHandler = function() {

    self.config.button.each(function() {

      var $this = $(this);
      var $container = $($this.attr('data-collapse'));

      $this.on('click', new Utils().throttle(function(e) {

        if ($this.attr('data-collapse-parent')) {
          self.accordion($this, $container);
        }

        var activeState = function() {
          if ($this.attr('data-collapse-alt-text')) {
            self.altText($this);
          }
        };

        if ($this.is('a')) {
          e.preventDefault();
        }

        self.containerVisibility($container, $this, activeState);
      }, 300));
    });
  }

  self.containerVisibility = function($container, $button, cb) {

    if ($container.hasClass('is-visible')) {
      self.hideContainer($container, $button, cb);
    } else {
      self.showContainer($container, $button, cb);
    }
  }

  self.accordion = function($button, $container) {
    var $parent = $($button.attr('data-collapse-parent'));
    var $otherContainers = $parent.find(self.config.containerEl.not($container));
    var $otherButtons = $parent.find(self.config.button.not($button));
    self.hideContainer($otherContainers, $otherButtons);
  }

  self.altText = function($button) {
    var oldText = $button.text();
    var newText = $button.attr('data-collapse-alt-text');
    $button
      .text(newText)
      .attr('data-collapse-alt-text', oldText);
  }

  self.showContainer = function($container, $button, cb) {

    if (!$container.hasClass('is-visible') && !$container.hasClass('velocity-animating')) {

      var $stickySidebar = $('[data-sticky-sidebar]');

      if ($stickySidebar.length) {
        var $stickyParent = $('[data-sticky-sidebar]').parent();
        var fixHeight = $stickyParent.height();
        $stickyParent.css('height', fixHeight);
      }

      $button.addClass('is-active');
      $container
        .addClass('is-visible')
        .velocity('slideDown',{
          duration: 400,
          easing: 'easeOutQuart'
        })
        .velocity({
          opacity: 1
        },{
          duration: 300,
          complete: function() {

            $button.attr('aria-expanded', 'true');

            if (typeof cb === 'function') {
              cb();
            }

            if ($stickySidebar.length) {
              $stickyParent.css('height', 'auto');
              $(document.body).trigger('sticky_kit:recalc');
            }
          }
        });
    }
  }

  self.hideContainer = function($container, $button, cb) {

    if ($container.hasClass('is-visible') && !$container.hasClass('velocity-animating')) {

      $button.removeClass('is-active');
      $container
        .removeClass('is-visible')
        .velocity({
          opacity: 0
        },{
          duration: 200
        })
        .velocity('slideUp',{
          duration: 400,
          easing: 'easeOutQuart',
          complete: function() {

            $button.attr('aria-expanded', 'false');

            if (typeof cb === 'function') {
              cb();
            }

            $(document.body).trigger('sticky_kit:recalc');
          }
        });
    }
  }

  self.init = function() {
    self.clickHandler();
  }
};

module.exports = Collapse;
